import * as Yup from 'yup';

export const validatePhone = Yup.string().matches(
  /^\(\d{3}\) \d{3}-\d{4}$/,
  'Phone number is invalid'
);
